/* Site-Specific JavaScript */
document.addEventListener('DOMContentLoaded', function () {
    AOS.init({
        once: true
    });

    var header = document.getElementById('site-header');

    function headerScroll() {
        if (window.scrollY > 0) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }
    }

    const body = document.querySelector('body');
    if (body.classList.contains('home')) {
        window.addEventListener('scroll', headerScroll);
        headerScroll();
    }

    jq(".news-slider").on('afterChange', () => {
        let curr_slide = jq(".news-slider").slick('slickCurrentSlide');
        document.querySelector(`.news-slider div[data-slick-index="${curr_slide}"] a`).focus();
    });
});
